import { gql } from 'graphql-tag';

export const GET_ESTUDIANTE_BY_SWARMOB_DATA = gql`
	query getEstudiantesBySwarmobData($curso: uuid!, $nombre: String!, $apellido: String!, $password: String!) {
		buscar_estudiantes_por_curso_password(
			args: { curso: $curso, nombre_param: $nombre, apellido_param: $apellido, password_param: $password }
		) {
			key
			firebase_uid
			nombre
			apellido
			active
			grupo_key
			password
			avatarPath
			rol
			curso {
				year
				key
				nivel
				identificadorNivel
			}
			colegio {
				nombre
				key
			}
		}
	}
`;

export const GET_ESTUDIANTE_BY_PASSWORD = gql`
	query getEstudianteByPassword1($password: String!, $colegioNombre: String!, $nombre: String!) {
		estudiantes(
			where: {
				_and: [
					{ password: { _eq: $password } }
					{ colegio: { nombre: { _ilike: $colegioNombre } } }
					{ nombre: { _ilike: $nombre } }
				]
			}
		) {
			key
			firebase_uid
			nombre
			apellido
			active
			grupo_key
			password
			avatarPath
			rol
			curso {
				year
				key
				nivel
				identificadorNivel
			}
			colegio {
				nombre
				key
			}
		}
	}
`;

export const GET_USER_ACCOUNT_BY_CREDENTIALS_DOCENTE = gql`
	query getUserAccountByCredentials(
		$colegio_key: uuid
		$nombre: String!
		$apellido: String!
		$password: String!
		$tipoUsuario: String!
	) {
		buscar_usuario_por_credencialesv2(
			args: {
				colegio_param: $colegio_key
				institucion_param: null
				nombre_param: $nombre
				apellido_param: $apellido
				password_param: $password
				tipousuario_param: $tipoUsuario
			}
		) {
			key
			nombre
			apellido
			avatarPath
			user_cuentas(
				where: {
					active: { _eq: true }
					password: { _eq: $password }
					tipoUsuario: { _eq: $tipoUsuario }
					colegio_key: { _eq: $colegio_key }
				}
			) {
				key
				rol
				tipoUsuario
				active
				email
				colegio_key
				institucion_key
				firebase_uid
				institucion {
					key
					nombre
				}
				colegio {
					key
					nombre
				}
			}
		}
	}
`;
export const GET_USER_ACCOUNT_BY_CREDENTIALS_MONITOR = gql`
	query getUserAccountByCredentials(
		$institucion_key: uuid
		$nombre: String!
		$apellido: String!
		$password: String!
		$tipoUsuario: String!
	) {
		buscar_usuario_por_credencialesv2(
			args: {
				colegio_param: null
				institucion_param: $institucion_key
				nombre_param: $nombre
				apellido_param: $apellido
				password_param: $password
				tipousuario_param: $tipoUsuario
			}
		) {
			key
			nombre
			apellido
			avatarPath
			user_cuentas(
				where: {
					active: { _eq: true }
					password: { _eq: $password }
					tipoUsuario: { _eq: $tipoUsuario }
					institucion_key: { _eq: $institucion_key }
				}
			) {
				key
				rol
				tipoUsuario
				active
				email
				colegio_key
				institucion_key
				firebase_uid
				institucion {
					key
					nombre
				}
				colegio {
					key
					nombre
				}
			}
		}
	}
`;
